import { computed } from "vue";
import { useOperations } from "@/api/operations";
import { useSession } from "@/composables/useSession";

/** Changes waiting for approval (the nav badge). Sidebar and tab bar share one query. */
export function usePendingApprovals() {
  const { me } = useSession();
  const pending = useOperations(() => ({ status: "awaiting_approval", all: Boolean(me.value?.canApprove) }));
  return computed(() => pending.data.value?.length ?? 0);
}
